<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00002">
<h2 class="nobreak">LIST OF ILLUSTRATIONS</h2>
</div>
<table class="calibre13" summary="">
<tbody class="calibre14"><tr class="calibre15"><td class="calibre16">A frolic would follow</td>
<td class="tdr"><a href="#/Text/Section0002#Page_0"> <i class="calibre11">Frontispiece</i></a></td>
</tr>
<tr class="calibre15"><td class="tdr" colspan="2"><span class="allsmcap">FACING<br class="calibre9"/>
PAGE</span></td>
</tr>
<tr class="calibre15"><td class="calibre16">Most unpromising she was, at the first glance</td>
<td class="tdr"><a href="#/Text/Section0005#Page_6">      6</a></td>
</tr>
<tr class="calibre15"><td class="calibre16">She fled with him down the aisle</td>
<td class="tdr"><span href="#/Text/Section0011#Page_84" title="Link target outside of Sample">      84</span></td>
</tr>
<tr class="calibre15"><td class="calibre16">Van caught up with Piggy at the far end of the lawn</td>
<td class="tdr"><span href="#/Text/Section0016#Page_152" title="Link target outside of Sample">      152</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?6902cee5